var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleDent1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#aa8fc2;}.cls-2,.cls-4{mix-blend-mode:screen;}.cls-3{opacity:0;}.cls-5{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.76,
    y: 39.43,
    width: 173.58,
    height: 110.57,
    rx: 20.53,
    ry: 20.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.34,125.22v47.93c0,7.25-8.77,10.88-13.89,5.75l-53.51-53.51,67.4-.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.11,
    y: 63.88,
    width: 108.01,
    height: 20.55,
    rx: 10.28,
    ry: 10.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.11,
    y: 102.77,
    width: 68.13,
    height: 20.55,
    rx: 10.28,
    ry: 10.28
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleDent1);
export default __webpack_public_path__ + "static/media/title-dent-1.a970472192ad79c3cfb2980fe61e5698.svg";
export { ForwardRef as ReactComponent };